import { Input } from "@/components/ui/input";

/** Format a numeric value with Indonesian thousand separators. Accepts string or number. */
export const formatNumberID = (v) => {
  if (v === "" || v === null || v === undefined) return "";
  const digits = String(v).replace(/[^\d]/g, "");
  if (!digits) return "";
  return Number(digits).toLocaleString("id-ID");
};

/** Strip formatting to raw digit string */
export const parseNumberID = (s) => String(s || "").replace(/[^\d]/g, "");

/**
 * RupiahInput — formatted currency input.
 * Value is passed as a raw number string via onChange({target:{value:'150000000'}}).
 */
export default function RupiahInput({ value, onChange, className = "", ...rest }) {
  const display = formatNumberID(value);
  return (
    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-xs font-mono-num pointer-events-none">Rp</span>
      <Input
        {...rest}
        type="text"
        inputMode="numeric"
        value={display}
        onChange={(e) => {
          const raw = parseNumberID(e.target.value);
          onChange({ target: { value: raw } });
        }}
        className={`pl-9 font-mono-num ${className}`}
      />
    </div>
  );
}
